export const workData = {
  title: 'Engineering approach',
  workStyle: [
    'Start with constraints from users, environment, and deployment conditions.',
    'Design offline-safe flows and failure recovery before scaling features.',
    'Build modular interfaces between firmware, cloud services, and applications.',
    'Ship fast, instrument behavior, then harden for production reliability.'
  ],
  goals: [
    'Build real-world products, not demo-only prototypes.',
    'Design scalable IoT systems with long-term maintainability.',
    'Contribute to startup-driven product development in embedded + software domains.'
  ]
}
